export const channelEn = {
    tijiaozhiliao:"Submission of information",
    txgsxx:'Fill in company information, upload business license, fill in your collection information for settlement',
    sqqy:'Application for contract signing',
    ddzzsh:'Wait for the qualification review (1-3 working days) to pass and sign the SMS contract',
    rzcg:'Successful entry',
    lrxx:'Input information',
    ptsh:'The platform is audited, and the business can be started after passing the audit',
    ljjr:'Immediate accession',
    txrzzl:'Fill in the residence information',
    ptsh:'Platform audit',
    rzcg:'Successful entry',
    zltjcg:'Data submitted successfully, please wait patiently for platform review',
    shsb:'Review failed, please fill in the registration information again and submit',
    shyj:'Audit opinion',
    cxtx:'Rewrite',
    shtg:'Congratulations, the channel information has been approved',
    jrjg:'Enter the channel management background',
    qudsf:'Channel identity:',
    qyzf:'Enterprise / government (including enterprise, government, institution, group, organization)',
    geren:'personal',
    zhuanjia:'expert',
    qiyemc:'Enterprise name：',
    qsrqymc:'Please enter the enterprise name',
    youxiang:'Mailbox:',
    qingshuruyouxiang:'Please enter email',
    shoujihaoma:'phone number:',
    qingshurusj:'Please input the mobile phone',
    tyjgdm:'Unified organization code certificate:',
    qsrtyjgdm:'Please enter unified organization code certificate',
    qyszd:'Location of enterprise:',
    qsrxxdz:'Please enter the detailed address',
    gsclny:'Date of incorporation:',
    qxzrq:'Please select a date',
    gszczb:"Registered capital of the company:",
    qsrgszczb:'Please enter the registered capital of the company',
    gsjj:'Company profile:',
    qsrgsjj:'Please enter company profile',
    scfrsfz:'Upload the scanned copy of legal person id card:',
    sfzzm:'Upload ID card on the front',
    sfzfm:'Upload the back of ID card',
    qyzyyz:'Upload the copy of business license (with official seal) scanning copy:',
    zzzs:'Upload the scanned copy of qualification certificate (multiple copies can be selected):',
    scjjzl:'Upload profile material:',
    scsqs:"Upload the power of attorney of the operator of the platform's registered account:",
    baocun:'Save Draft',
    tijiao:'Submission',
    woyiydty:'read and agree',
    xiyi:'Agreement on product testing and certification platform of CCPIT',
    zsxm:'Real name:',
    qsrzsxm:'Please enter your real name',
    suozaidi:'Location:',
    guojia:'Country',
    scbljl:'Upload the scanning file of no bad record issued by the public security organ:',
    zjmc:'Name of expert:',
    qsrzjmc:'Please enter the name of the expert',
    zjszdz:"Expert's address:",
    zjzxxm:'Expert consultation project:',
    qingxunzhe:'choose',
    zjzl:"Expert qualification:",
    zjjl:'Expert profile:',
    qsrzjjj:'Please enter the expert profile',
    scsfzsmj:'Upload scanning copy of expert ID card:',
    sczjzzsmj:'Upload the scanned copies of expert qualification certificate:',
    sczjlw:'Upload personal papers of experts:',
    qxzgj:'Please select a country',
    qxzsheng:'Please choose Province',
    qxzshi:'Please select the city.',
    qxzfu:'Please select service',
    qxzhy:'Please select industry',
    qxzzlnf:'Please select a qualification year',
    youxiangbwk:'Mailbox cannot be empty',
    qingshuruzqyx:'Please enter the correct email format',
    shoujibwk:'Mobile number cannot be empty',
    qingshuruzqsj:'Please input the correct mobile number',
    qsrgszczj:"Please enter the company's registered capital",
    qxzgsclnf:'Please select the year of incorporation',
    cdxz:'3 to 12 characters in length'
}


// WEBPACK FOOTER //
// ./src/lang/home/channel/channelEn.js